import { createUuid } from '~/_shared/utils/createUuid';
import { getBoundaryTerritoryGroupSettingsStyleDefaults } from '~/boundary/settings/defaultBoundaryTerritoryStyles';
import { DATA_LAYER_TOOL_DEFAULT_NUMBER_OF_RANGES } from '~/sidebar/sidebarApps/mapTools/dataLayersTool/dataLayersTool.helpers';
import type { DemographicIdCode } from '~/store/boundaryGroups/boundaryGroups.repository';
import type { DemographicRegion } from '~/store/demographics/demographics.types';
import type { DataLayerTemplate } from '~/store/frontendState/mapTools/dataLayers/dataLayers.repository';
import type {
  DataLayer, DataLayerId,
} from './mapSettingsDataLayers.state';

export const createDataLayerId = (): DataLayerId => createUuid();

export const createDataLayer = ({
  id, title, region, demographics, settings,
}: {
  title: string;
  region: DemographicRegion;
  demographics: ReadonlyArray<DemographicIdCode>;
} & Partial<DataLayer>): DataLayer => ({
  id: id || createDataLayerId(),
  data: {
    title,
    region,
    demographics: demographics || [],
  },
  settings: {
    ...getDefaultDataLayerSettings(),
    ...(settings ? settings : {}),
  },
});

export const getDefaultDataLayerSettings = () => ({
  style: getBoundaryTerritoryGroupSettingsStyleDefaults(),
  numberOfRanges: DATA_LAYER_TOOL_DEFAULT_NUMBER_OF_RANGES,
  disableMapInteraction: false,
});

export const createDataLayerFromTemplate = (dataLayerTemplate: DataLayerTemplate): DataLayer => ({
  ...createDataLayer({
    ...dataLayerTemplate.data.data,
    settings: dataLayerTemplate.data.settings,
  }),
  fromTemplate: dataLayerTemplate.id,
});
